<template>
  <RecordViewWrapper>
    <sdPageHeader title="User">
      <template #subTitle>
        <sdButton class="btn-add_new" size="default" type="primary">
          <router-link to="/masters/user-add"> <sdFeatherIcons type="plus" size="14" /> Tambah</router-link>
        </sdButton>
      </template>
      <template #buttons>
        <div class="search-box">
          <span class="search-icon">
            <sdFeatherIcons type="search" size="14" />
          </span>
          <a-input
            @change="handleSearch"
            v-model:value.trim="formState.searchItem"
            type="text"
            name="recored-search"
            placeholder="Search Here"
          /></div
      ></template>
    </sdPageHeader>

    <Main>
      <a-row :gutter="15">
        <a-col class="w-100" :md="24">
          <sdCards headless>
            <div v-if="isLoading" class="spin">
              <a-spin />
            </div>

            <div v-else>
              <TableWrapper class="table-data-view table-responsive">
                <a-table
                  :pagination="{ pageSize: 10, showSizeChanger: true }"
                  :dataSource="dataSource"
                  :columns="columns"
                />
              </TableWrapper>
            </div>
          </sdCards>
        </a-col>
      </a-row>
    </Main>
  </RecordViewWrapper>
</template>

<script>
import { RecordViewWrapper } from '../../../components/crud/style';
import { computed, onMounted, reactive } from 'vue';
import { Main, TableWrapper } from '../../styled';
import { useStore } from 'vuex';
import { Modal } from 'ant-design-vue';

const columns = [
  {
    title: 'Nama',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Divisi',
    dataIndex: 'divisi_id',
    key: 'divisi_id',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Role',
    dataIndex: 'role',
    key: 'role',
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    key: 'action',
    width: '90px',
  },
];

const ViewPage = {
  name: 'ViewPage',
  components: { RecordViewWrapper, Main, TableWrapper },
  setup() {
    const { state, dispatch } = useStore();
    const crud = computed(() => state.crud.data);
    const isLoading = computed(() => state.crud.loading);

    onMounted(() => {
      dispatch('axiosCrudGetData', 'user');
    });

    const handleDelete = (id, name) => {
      Modal.confirm({
        title: 'Konfirmasi',
        content: `Apakah Anda yakin ingin menghapus ${name}?`,
        okText: 'Hapus',
        cancelText: 'Batal',
        onOk: () => {
          dispatch('axiosDataDelete', {
            id,
            url: 'user',
            getData: () => {
              dispatch('axiosCrudGetData', 'user');
            },
          });
        },
      });
    };

    const handleReset = (id, name) => {
      Modal.confirm({
        title: 'Konfirmasi',
        content: `Apakah Anda yakin ingin me-reset password ${name}?`,
        okText: 'Reset Password',
        cancelText: 'Batal',
        onOk: () => {
          dispatch('axiosDataResetPassword', {
            id,
            getData: () => {
              dispatch('axiosCrudGetData', 'user');
            },
          });
        },
      });
    };

    const handleUnlock = (id, name) => {
      Modal.confirm({
        title: 'Konfirmasi',
        content: `Apakah Anda yakin ingin membuka kunci user ${name}?`,
        okText: 'Unlock',
        cancelText: 'Batal',
        onOk: () => {
          dispatch('axiosDataUnlockUser', {
            id,
            getData: () => {
              dispatch('axiosCrudGetData', 'user');
            },
          });
        },
      });
    };

    const formState = reactive({
      searchItem: '',
    });

    const dataSource = computed(() =>
      crud.value.length
        ? crud.value.map((data, key) => {
            const { id, name, divisi, email, roles } = data;

            return {
              key: key + 1,
              name,
              divisi_id: divisi ? divisi.name : '',
              email,
              // role: roles && roles.length ? roles[0].name : '',
              role: roles && roles.length ? roles.map(role => role.name).join(', ') : '',
              action: (
                <div class="table-actions">
                  <router-link class="delete" to={`/masters/user-edit/${id}`}>
                    <sdFeatherIcons type="edit" size={14} title="Ubah" />
                  </router-link>
                  {data.is_locked ? (
                    <>
                      &nbsp;&nbsp;&nbsp;
                      <router-link class="delete" onClick={() => handleUnlock(id, data.name)} to="#">
                        <sdFeatherIcons type="unlock" size={14} title="Unlock" />
                      </router-link>
                    </>
                  ) : null}
                  &nbsp;&nbsp;&nbsp;
                  <router-link class="delete" onClick={() => handleReset(id, data.name)} to="#">
                    <sdFeatherIcons type="refresh-cw" size={14} title="Reset Password" />
                  </router-link>
                  &nbsp;&nbsp;&nbsp;
                  <router-link class="delete" onClick={() => handleDelete(id, data.name)} to="#">
                    <sdFeatherIcons type="trash-2" size={14} title="Hapus" />
                  </router-link>
                </div>
              ),
            };
          })
        : [],
    );

    const handleSearch = () => {
      dispatch('axiosDataSearch', { url: 'user', filter: formState.searchItem });
    };

    return {
      formState,
      columns,
      isLoading,
      crud,
      dataSource,
      handleDelete,
      handleReset,
      handleUnlock,
      handleSearch,
    };
  },
};

export default ViewPage;
</script>
